import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  IconButton,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { useTranslation } from '../../hooks/useTranslation';

type CashoutDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  bettingInprogress: boolean;
  cashoutAmount?: number;
};

const CashoutDialog: React.FC<CashoutDialogProps> = ({
  open,
  onClose,
  onConfirm,
  bettingInprogress,
  cashoutAmount,
}) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      className="stl-dialog rules-dialog"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle className="stl-dialog-title">
        <div className="title-close-icon">
          <div className="modal-title notification-title">
            {t("sports.cashout")}
          </div>
          <IconButton
            className="close-btn"
            onClick={onClose}
          >
            <Close className="close-icon" />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent className="stl-dialog-content">
        <div className="text-white text-center pt-3">
          <div className="text-lg mb-3">
            {t("sports.doYouWishToPerformCashout")}
          </div>
          {cashoutAmount !== undefined && cashoutAmount !== Infinity && (
            <div className="text-xl font-bold" style={{
              color: cashoutAmount >= 0 ? '#4ade80' : '#f87171',
              marginTop: '12px'
            }}>
              {cashoutAmount >= 0 ? '+' : ''}{cashoutAmount.toFixed(2)}
            </div>
          )}
        </div>
      </DialogContent>
      <div style={{ padding: '0 16px 16px', display: 'flex', justifyContent: 'center' }}>
        <Button
          size="medium"
          variant="contained"
          onClick={onConfirm}
          disabled={bettingInprogress}
          style={{
            backgroundColor: 'var(--ion-color-primary)',
            color: '#ffffff',
            minWidth: '120px'
          }}
        >
          {bettingInprogress ? t("common.processing") : t("sports.cashout")}
        </Button>
      </div>
    </Dialog>
  );
};

export default CashoutDialog;
